var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"result-card",on:{"click":_vm.handleSelectProduct}},[_c('p',{staticClass:"alias"},[_vm._v(_vm._s(_vm.product.style_id))]),_c('p',[_vm._v(_vm._s(_vm.product.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }